import React, { memo } from 'react'
import { MVR } from 'src/components/mvr/MVR'

const MVRPageComponent = () => {
  return <MVR />
}

export const MVRPage = memo(MVRPageComponent)
